import {Attributes} from '@components/modal/proparties_modal';
import {LinearProgress} from '@mui/material';

const Levels_item = ({item}: {item?: Attributes}) => {
  return (
    <div className="bg-white/[.30] border dark:border-grey border-light-grey md:w-3/5 p-4 rounded-lg mb-2">
      <div className="flex justify-between gap-x-2 mb-3">
        <span className="dark:text-white text-dark-grey font-[700] text-dark-navy lg:text-sm mbl:text-2xs">
          {item?.trait_type}
        </span>
        <span className="dark:text-white text-dark-grey font-[700] text-dark-navy lg:text-sm mbl:text-2xs">
          {item?.value} of {item?.max_value}
        </span>
      </div>

      <div>
        <LinearProgress
          variant="determinate"
          value={(Number(item?.value) / Number(item?.max_value)) * 100}
          className="bg-light-grey rounded-lg text-red !h-1.5"
          sx={{
            '& .MuiLinearProgress-barColorPrimary': {
              backgroundColor: '#00FF82',
            },
          }}
        />
      </div>
    </div>
  );
};

export default Levels_item;
